export default "__VITE_ASSET__Cm2UZ9n4__"